<template>
  <div class="asd-form">
    <label>{{ $t('common.name') }}</label>
    <input v-model="data.name" type="text" class="form-control">
    <label>Vlastnosti</label>
    <Multiselect
      v-if="data.propertyType"
      v-model="data.propertyType"
      v-help.mouse="'Tímto výběrem se nedá určit pořadí vlastnosti v typu.|Pořadí vždy závisí na pořadí vlastností nastavene v editaci vlastností'"
      label="name"
      trackBy="key"
      :options="$store.getters.propertyTypes"
      :max="-1"
    ></Multiselect>
    <div v-if="propertyWarnings.length">
      <div v-for="(w, i) in propertyWarnings" :key="i"
           class="alert alert-danger"
           role="alert"
      >
        <h4 class="alert-heading">
          Nekompatibilní vlastnosti - {{ w.entities.join(', ') }}
        </h4>
        <p v-html="w.message"></p>
      </div>
    </div>
    <template v-if="entityStateProperties.length > 0">
      <label>Stavy pro tento typ úkolu</label>
      <AssignStatesTable
        v-model="data.settings.graphs"
        :properties="entityStateProperties"
      ></AssignStatesTable>
    </template>
    <FormControls v-if="data.validUntil === null">
      <button class="asd-btn-delete" @click="disableProjectType()">
        Smazat
      </button>
      <button v-if="projectTypeId !== null"
              v-help.mouse="'Aktuální hodnoty uloží jako nový typ projektu.|Původní typ projektu nebude ovlivněn.'"
              class="asd-btn-confirm"
              @click="duplicate()"
      >
        Uložit jako nový
      </button>
      <button v-if="projectTypeId !== null" class="asd-btn-confirm" @click="save()">
        Uložit
      </button>
      <button v-if="projectTypeId === null" class="asd-btn-confirm" @click="create()">
        Vytvořit
      </button>
    </FormControls>
  </div>
</template>

<script>
import _ from 'lodash'
import Multiselect from 'CORE/components/utilities/vue-multiselect-ext'
import FormControls from 'CORE/components/form/controls'
import { currentTimestamp } from 'CORE/utils/date'
import PropertyQuery from 'CORE/utils/property-query'
import AssignStatesTable from 'CORE/components/form/assign-states-table'
import EventBus from 'CORE/bus'

const pq = new PropertyQuery()

export default {
    name: 'ProjectTypeForm',
    components: {
        Multiselect,
        FormControls,
        AssignStatesTable,
    },
    props: {
        projectTypeId: {
            type: String,
            required: false,
            default: _ => null,
        },
    },
    data: function() {
        return {
            data: {},
        }
    },
    computed: {
        entityStateProperties() {
            return _.filter(this.data.propertyType, pt => pt.type === 'ENTITY_STATE')
        },
        propertyWarnings() {
            const warnings = []
            const multipleEntityState = _.filter(this.data.propertyType, pt => _.get(pt, 'settings.systags.entityState', false))
            if (_.size(multipleEntityState) > 1) {
                warnings.push({
                    message: `Máte vybranou více než jednu vlastnost která má systémovou funkcionalitu "Stav".
                    Takovéto nastavení může vyůstit v neočekávané chování protože systém neví podle které vlastnosti stav projektu určit.
                    Odeberte entity a nechte pouze jednu nebo jednu z entit odznačte v nastavení jako "Stav"`,
                    entities: _.map(multipleEntityState, pt => _.get(pt, 'name')),
                })
            }
            return warnings
        },
    },
    created() {
        if (this.projectTypeId === null) {
            this.data = {
                id: this.$uuid.v4(),
                userDefined: true,
                propertyType: _.filter(this.$store.getters.propertyTypes, pt => _.get(pt, 'defaultProject', false)),
                validUntil: null,
            }
        } else {
            this.data = this.$store.getters.projectTypeById(this.projectTypeId)
        }

        if (!_.isPlainObject(this.data.settings)) {
            this.$set(this.data, 'settings', {})
        }
        if (!_.isPlainObject(this.data.settings.graphs)) {
            this.$set(this.data.settings, 'graphs', {})
        }

        console.assert(
            _.isString(_.get(this.data, 'id')),
            'Invalid ID after data creation (not existing ProjectType or invalid UUID creation)'
        )
    },
    methods: {
        async disableProjectType() {
            try {
                this.$set(this.data, 'validUntil', currentTimestamp())
                await this.$store.dispatch('updateProjectType', this.data)
                await this.$store.dispatch('projectTypesLoad')
                EventBus.$emit('FLASH_OK', { message: 'Uloženo' })
                this.$emit('done')
            } catch (e) {
                this.$set(this.data, 'validUntil', null)
                EventBus.$emit('FLASH_ERROR', e)
            }
        },
        async save() {
            try {
                await this.$store.dispatch('updateProjectType', this.data)
                await this.$store.dispatch('projectTypesLoad')
                EventBus.$emit('FLASH_OK', { message: 'Uloženo' })
                this.$emit('done')
            } catch (e) {
                EventBus.$emit('FLASH_ERROR', e)
            }
        },
        async create() {
            try {
                await this.$store.dispatch('createProjectType', this.data)
                await this.$store.dispatch('projectTypesLoad')
                EventBus.$emit('FLASH_OK', { message: 'Uloženo' })
                this.$emit('done')
            } catch (e) {
                EventBus.$emit('FLASH_ERROR', e)
            }
        },
        async duplicate() {
            this.data.id = this.$uuid.v4()
            this.data.name = `${this.data.name} - kopie`
            this.create()
        },
    },
}
</script>
